/**
 * Helper de routing pour le site public.
 *
 * Permet d'utiliser le même codebase pour 3 builds distincts :
 *   - CRM (mode par défaut) : le site public vit sous /site/*
 *   - SITE seul (REACT_APP_SITE_ONLY=true) : site institutionnel à la racine
 *   - SITE2 vente (REACT_APP_SITE_VENTE=true) : catalogue de biens à vendre à la racine
 *
 * Toutes les routes & liens du site public DOIVENT utiliser sitePath().
 */
export const SITE_ONLY = process.env.REACT_APP_SITE_ONLY === "true";
export const SITE_VENTE = process.env.REACT_APP_SITE_VENTE === "true";
export const SITE_BASE = SITE_ONLY ? "" : "/site";

/**
 * sitePath("/projets")  → "/site/projets" (mode CRM) ou "/projets" (mode SITE)
 * sitePath("")          → "/site"          (mode CRM) ou "/"          (mode SITE)
 */
export const sitePath = (p = "") => {
  if (!p || p === "/") return SITE_ONLY ? "/" : "/site";
  const cleaned = p.startsWith("/") ? p : `/${p}`;
  return `${SITE_BASE}${cleaned}`;
};
